import { Component, OnInit, ViewChild, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';

import { RequestHistory } from '@app/core';
import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-request-status-history',
  templateUrl: './request-status-history.component.html',
  styleUrls: ['./request-status-history.component.scss'],
})
export class RequestStatusHistoryComponent implements OnInit  {
  private _requestId: number;

  @Input() set requestId(value: number) {
    this._requestId = value;
    this.store.dispatch(new fromStore.RequestActions.LoadRequestHistory(value));
  }

  get requestId(): number {
    return this._requestId;
  }

  history$ = this.store.select(fromStore.selectRequestHistory);
  subscription: Subscription;
  dataSource: MatTableDataSource<RequestHistory> | null;
  displayedColumns = ['eventDate', 'requestStatusName', 'createdBy', 'remarks'];
  @ViewChild(MatSort) sort: MatSort;

  constructor(private store: Store<fromStore.State>) { }

  ngOnInit() {
    this.subscription = this.history$.subscribe(history => {
      if (history) {
        this.dataSource = new MatTableDataSource<RequestHistory>(history);
        this.dataSource.sort = this.sort;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/request-status-history/request-status-history.component.ts